// This component is used to convert native <select> and <option> elements
// into custom dropdowns. For clarity, all custom element names are prefaced 
// with 'mock' and all native elements are prefaced with 'native'



define([], function () {
    
    // function to close all mock select boxes
    function closeAllSelect() {
        let activeMockSelect = document.querySelector(".mock-select.active");

        if(!activeMockSelect) return;

        let activeWrapper = activeMockSelect.parentElement;
        
        let arrow = activeWrapper.querySelector("img") ? activeWrapper.querySelector("img") : activeWrapper.querySelector("svg");
        arrow.classList.remove('active');

        mockOptions = activeWrapper.querySelector(".mock-options");
        mockSelectElement = activeWrapper.querySelector(".mock-select");

        let searchBar = activeWrapper.querySelector(".search-bar");

        if(searchBar) {
            searchBar.classList.add("hide");
            searchBar.value = '';
            searchBar.disabled = true;
            mockSelectElement.classList.remove("hide");

            mockOptions.querySelectorAll("div").forEach(option => {
                option.classList.remove("hide");
            })
        }

        mockSelectElement.classList.remove("active");
        mockOptions.classList.remove("active");
    }

    let listenerLaunched = false;

    // add an event listener to all document clicks which will close any open mock select boxes
    function initDocumentListener() {
        if (!listenerLaunched) {
            
            document.addEventListener("click", function (e) {
                let pn = e.target.parentNode;
                if (!pn) return;
                try {
                    while (!(pn && pn.classList && pn.classList.contains("custom-select"))) {
                        if (!pn.parentNode) {
                            break;
                        }
                        pn = pn.parentNode;
                    }
                } catch (e) {
                    console.log(e);
                }

                if (pn === document) {
                    closeAllSelect();
                }
            });

            listenerLaunched = true;
        }
    }

    /* 
        targetElement: native select wapper element (DOM element object)
        optionSelectCallback: fires when user selects a mock option (function)
        onLoadCallback: fires when dropdown is initialized (function)
    */

    return function (targetElement, optionSelectCallback, onLoadCallback) {

        let nativeSelectElement = targetElement.querySelector('select');
        let nativeSelectOptions = targetElement.querySelectorAll('select option');
        let id = nativeSelectElement.getAttribute("id");
        let items = [];

        let mockOptionEventListener = (event) => {

            let mockOptionWrapper = event.target.parentNode;
            let mockSelectElement = mockOptionWrapper.previousSibling;
            let index = Array.prototype.indexOf.call(mockOptionWrapper.children, event.target)

            // select the corresponding native option
            nativeSelectElement[index].selected = true;
    
            if (optionSelectCallback) optionSelectCallback(nativeSelectElement[index].value, id, event.target);
    
            // remove existing 'selected' class
            let currentSelection = mockOptionWrapper.querySelector(".active");
            if(currentSelection) currentSelection.classList.remove('active');
    
            // update mockSelect value 
            mockSelectElement.innerHTML = event.target.innerHTML;
    
            // add 'selected' class to clicked option
            event.target.classList.add("active");
    
            //update native select value
            nativeSelectElement.selectedIndex = index;
    
            closeAllSelect();
        }

        let reset = () => {
            items = [...targetElement.querySelectorAll(".mock-options div")];
            if(!items.length) return;
            items.forEach(i => {
                i.classList.remove("active");
            });
            items[0].classList.add("active");
            targetElement.querySelector(".mock-select").innerHTML = items[0].innerHTML;
        };

        // programatically select an option
        let chooseOption = (value) => {
            let index = 0;
            targetElement.querySelectorAll("option").forEach((option, i) => {
                if (option.value == value) {
                    index = i;
                }
            });
            items = [...targetElement.querySelectorAll(".mock-options div")];
            items.forEach(i => {
                i.classList.remove("active");
            });
            items[index].classList.add("active");
            targetElement.querySelector(".mock-select").innerHTML = items[index].innerHTML;
            targetElement.querySelector("select").value = value;
        };

        // function for adding a new option to the native and mock select after dropdown has been
        // alphabetize parameter accepts true or false, if you want new option placed in alphabetical order
        // set maintainSelection to true if you don't want the new option selected after adding
        let addOption = (value, text, alphabetize, maintainSelection) => {

            let mockOptionsWrapper = targetElement.querySelector(".mock-options");

            // remove selected class from drop down
            mockOptions = [...mockOptionsWrapper.querySelectorAll(".mock-option")];

            // build new mock option, add it to the wrapper, and make it active
            let newItem = document.createElement("div");
            newItem.classList.add("mock-option");
            newItem.innerText = text;
            newItem.dataset.value = value;
            let itemPlaced = false;
            let lastMockOption= mockOptions.slice(-1)[0];
            let itemPosition = 0;

            mockOptions.forEach((option, i) => {
                // remove old active option if required
                if(!maintainSelection) {
                    option.classList.remove("active")
                }
                
                if(alphabetize && !itemPlaced) {
                    if(text.toLowerCase() < mockOptions[i].firstChild.data.trim().toLowerCase()) {
                        // place new option in alphabetical position
                        mockOptionsWrapper.insertBefore(newItem, mockOptions[i]);
                        itemPlaced = true;
                    }

                    if(text.toLowerCase() > lastMockOption.firstChild.data.trim().toLowerCase()) {
                        // place alphabetically at the end of the options
                        mockOptionsWrapper.insertBefore(newItem, lastMockOption.nextSibling);
                        itemPlaced = true;
                    }

                    itemPosition = i;
                }
            });
            
            if(!itemPlaced) {
                // place item at top of list 
                mockOptionsWrapper.insertBefore(newItem, mockOptionsWrapper.firstChild);
            }

            if(!maintainSelection) {
                // select new option
                newItem.classList.add("active");
                // populate mock select with new text
                targetElement.querySelector(".mock-select").innerText = text;
            }

            // add new <option> to the native select element
            let nativeSelect = targetElement.querySelector("select");
            let newOption = document.createElement("option");
            newOption.innerText = text;
            newOption.setAttribute("value", value);
            nativeSelect.insertBefore(newOption, nativeSelect.children[itemPosition]);
            
            if(!maintainSelection) {
                newOption.selected = true;
                nativeSelect.value = value;
            }

            newItem.addEventListener("click", function (event) {
                if(event.target.classList.contains("mock-option")) {
                    mockOptionEventListener(event);
                }
            })

        };

        let removeOption = (valueToRemove, textToRemove, performReset) => {
            // update visual dropdown
            let mockOptions = targetElement.querySelectorAll(".mock-options .mock-option");
            let currentSelection = targetElement.querySelector(".mock-options .mock-option.active");

            nativeSelectOptions = targetElement.querySelectorAll('select option');

            if(currentSelection.dataset.value === valueToRemove && performReset !== false) {
                performReset = true;
            }

            mockOptions.forEach(option => {
                let optionText = option.firstChild.data;
                if (optionText.trim() === textToRemove.trim()) {
                    option.remove();
                    if(performReset) {
                        reset();
                    }
                }
            })

            nativeSelectOptions.forEach(option => {
                if (option.value.trim() === valueToRemove.trim()) {
                    option.remove();
                }
            })
        };

        let info = () => {
            return {
                targetElement
            }
        }
        // Check if dropdown has already been populated
        let mockDropdownExists = Boolean(document.querySelector(`[data-origin-id="${id}"`) && id !== null)

        // build mock dropdown if it hasn't been already
        if (!mockDropdownExists) {

            // Create a new <div> that will replace the <select> element
            let mockSelectElement = document.createElement("div");
            mockSelectElement.setAttribute("class", "mock-select");
            mockSelectElement.setAttribute("data-origin-id", id);

            // add new mock select element to document
            targetElement.appendChild(mockSelectElement);

            // Create a new <div> to contain the mock select options
            mockOptionsWrapper = document.createElement("DIV");
            mockOptionsWrapper.setAttribute("class", "mock-options");

            // loop through native select options
            nativeSelectOptions.forEach((nativeOption, i) => {
                // determine if mock option should have 'active' class
                let active = false;
                // if a default-index is set on the element, make the desired index active
                if (targetElement.getAttribute("data-default-index")) {
                    if(targetElement.getAttribute("data-default-index") * 1 === i) {
                        active = true
                        nativeSelectElement.selectedIndex = i;
                    }
                // otherwise match the native select index
                } else {
                    if (i === nativeSelectElement.selectedIndex) {
                        active = true
                    }
                }

                let nativeOptionData = nativeOption.dataset;

                // create new <div> for each mock option
                let mockOption = document.createElement("div");
                mockOption.classList.add("mock-option");
                if(active) mockOption.classList.add("active");

                mockOption.dataset = nativeOption.dataset;
                mockOption.dataset.value = nativeOption.value;
                
                if(nativeOptionData) {
                    for (const property in nativeOptionData) {
                        mockOption.dataset[property] = nativeOptionData[property];
                    }
                }

                mockOption.innerHTML = nativeOption.innerHTML;
                mockOptionsWrapper.appendChild(mockOption);
            })

            // display the selected value in the mock select element
            let selectedIndex = nativeSelectElement.selectedIndex;
            mockSelectElement.innerHTML = nativeSelectElement.options[selectedIndex].innerHTML;

            let mockOptions = mockOptionsWrapper.querySelectorAll("div");

            // add event listeners for each mock option
            mockOptions.forEach((mockOption, index) => {
                mockOption.addEventListener("click", (event) => {
                    if(event.target.classList.contains("mock-option")) {
                        mockOptionEventListener(event);
                    }
                })
            })

            let searchable = mockOptions.length > 9 ? true : false;
            let searchHeightSet = false;

            if (searchable) {
                mockOptionsWrapper.classList.add("scroll");

                // build input field for search terms
                let searchInput = document.createElement("input");
                searchInput.setAttribute("placeholder", "Type to search");
                searchInput.setAttribute("class", "hide search-bar");
                searchInput.disabled = true;

                searchInput.addEventListener("input", (event) => {
                    
                    mockOptions.forEach(option => {
                        let lowerCaseOption = option.innerText.toLowerCase();
                        let lowerCaseValue = event.target.value.toLowerCase();
                        if(lowerCaseOption.includes(lowerCaseValue)) {
                            option.classList.remove("hide");
                        } else {
                            option.classList.add("hide");
                        }
                    })
                })
    
                let mockSelect = targetElement.querySelector(".mock-select");
                // add hidden search field to wrapper
                targetElement.insertBefore(searchInput, mockSelect);
            }

            // add mock options wrapper to the target element
            targetElement.appendChild(mockOptionsWrapper);

            // event listener for opening/closing the mock options
            mockSelectElement.addEventListener("click", (e) => {

                const targetClassList = [...e.target.classList];
                const parentNode = e.target.parentNode;

                let arrow = parentNode.querySelector("img") ? parentNode.querySelector("img") : parentNode.querySelector("svg");
                arrow.classList.add('active');

                // When the select box is clicked, close any other select boxes,
                // and open/close the current select box: */
                closeAllSelect();

                e.stopPropagation();

                // if the dropdown was initially open,
                // the 'closeAllSelect' call above will have toggled it.
                // otherwise, we can open it now
                if (!targetClassList.includes("active")) {
                    e.target.nextSibling.classList.add("active");
                    e.target.classList.add("active");
                    arrow.classList.add('active');
                }
                
                if(searchable) {
                    e.target.classList.add("hide");
                    let searchBar = parentNode.querySelector(".search-bar");
                    if(!searchHeightSet) {
                        searchBar.setAttribute("style", `height: ${mockSelectElement.parentElement.offsetHeight}px;`)
                        searchHeightSet = true;
                    }
                    searchBar.classList.remove("hide");
                    searchBar.disabled = false;
                    searchBar.focus();
                }
            });
        }

        if (onLoadCallback) {
            onLoadCallback(targetElement);
        }

        initDocumentListener();

        return {
            reset,
            chooseOption,
            addOption,
            removeOption,
            info
        };

    }
});